<div class="usage-list">
  <ng-container *ngIf="organizations?.length > 0; else noOrganizations">
    <ts-algorithm-usage-detail
      *ngFor="let organization of organizations"
      [organization]="organization"
      [language]="language"
    >
    </ts-algorithm-usage-detail>
  </ng-container>
  <ng-template #noOrganizations>
    <div class="no-organizations-message" style="text-align: center; margin-top: 1rem">
      {{ 'table.algorithms.switch_algorithm_dialog.no_organizations' | translate }}
    </div>
  </ng-template>
</div>
